<template>
    <form id="onboarding-de" class="wrapper" role="form" method="post" @submit.prevent="submit" novalidate autocomplete="off">
        <div class="onboarding-info">
            <span class="headline-sm text-bold text-violet">Danke für Ihre Mailadresse!</span>
            <p class="text-bold text-violet">Starten Sie einfach mit Vitadio – buchen Sie jetzt einen kostenlosen Beratungstermin und erhalten Sie persönliche Unterstützung.</p>
        </div>

        <div class="form-wrapper-basic">
            <div>
                <div class="input-wrapper form-input-radio">
                    <div class="radio-wrapper">
                        <input type="radio" name="consultation" value="true" id="consultation-true" checked>
                        <label class="label-static" for="consultation-true" @click="hideDatetime = false">Ich möchte ein Telefonat vereinbaren, um Unterstützung bei den ersten Schritten zu erhalten.</label>
                    </div>
                </div>

                <div :hidden="hideDatetime">
                    <form-input-type-text name="name" label="Name" full-border></form-input-type-text>

                    <form-input-type-phone-number
                        name="phone"
                        label="Rufnummer"
                        :errors="errors.phone"
                        phoneCountry="de"
                        required
                        full-border
                    ></form-input-type-phone-number>

                    <div class="col-2">
                        <div class="input-wrapper form-input-datepicker input-has-full-border">
                            <label for="datepicker-call" :class="['is-float-label', {'float-label-active': date !== null}]">Datum auswählen</label>
                            <input 
                                type="text" 
                                name="datepicker-call" 
                                id="datepicker-call" 
                                :class="['input-datepicker full-border', {'input-error-border': errors && errors.datetime && (slots === null || (slots && slots.length === 0))}]"
                                placeholder="Datum auswählen"
                                readonly
                            >
                            <span class="bs-caret"><span class="caret"></span></span>
                        </div>
                        
                        <div :class="['input-wrapper form-input-select input-has-full-border full-border', {'form-input-select--empty' : !slots || (slots && slots.length === 0), 'input-error-border': errors && errors.datetime && (slots === null || (slots && slots.length === 0))}]">
                            <label v-if="slots && slots.length === 0" for="" class="is-float-label">kein freier Termin</label>
                            <label v-else :class="['is-float-label', {'float-label-active': slots && slots.length > 0}]">Uhrzeit auswählen</label>
                            <select name="time" id="time" required data-none-selected-text="" data-none-results-text="Nichts gefunden">
                                <option v-for="(option, index) in slots" :key="index" :value="option">
                                    <div class="content">
                                        <span>{{ option.substr(0, 5) }}</span>
                                    </div>
                                </option>
                            </select>
                        </div>
                    </div>

                    <form-input-error
                        v-if="errors && errors.datetime && (slots === null || (slots && slots.length === 0))"
                        :error="__(errors.datetime[0])"
                    ></form-input-error>
                </div>
            </div>

            <span class="form-divider">oder</span>

            <div>
                <div class="input-wrapper form-input-radio">
                    <div class="radio-wrapper">
                        <input type="radio" name="consultation" value="false" id="consultation-false">
                        <label class="label-static" for="consultation-false" @click="hideDatetime = true">Ich weiß bereits, wie ich mit Vitadio loslegen kann und&nbsp;benötige kein Telefonat.</label>
                    </div>
                </div>
            </div>

            <v-button label="Weiter" size="lg" type="submit" full-width></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                errors: {},
                hideDatetime: false,
                token: null,
                slots: null,
                client: null,
                date: null,
                daktelaCalls: null
            }
        },

        mounted() {
            this.login()
            
            setTimeout(() => {
                $('#time').selectpicker({})
                this.initDatepicker()
            }, 100);
        },

        computed: {
        },

        methods: {
            submit() {
                let that = this
                this.data.variant = 'B'
                this.data.datetime = this.date+" "+$('#time').val()
                //this.data.datetime = "2022-07-21 09:00:00"
                this.data.phone_country = $('#phone_country').val()
                this.data.phone = $('#phone').val()
                this.data.name = $('#name').val()
                this.data.check = this.hideDatetime ? null : true

                if(this.data.name === "") {
                    this.data.name = "Anonym"
                }

                if(this.hideDatetime) {
                    this.data.datetime = null
                    this.data.phone_country = null
                    this.data.phone = null
                }

                axios
                    .post('api/web_pre_registration_form/' + this.data.id, this.data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        if(!that.hideDatetime) {
                            window.dataLayer.push({
                                event: 'pre_registration_web',
                                conversion: 'Phone number received'
                            })
                        }

                        setTimeout(() => {
                            this.$emit('clicked', e.data)
                        }, 250);
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true) 
                    })
            },
            login() {
                var loginClient = new JSONRpcClient({
                    url: 'https://user-api.simplybook.me/login',
                    onerror: function (error) {
                        alert(error)
                    }
                })

                this.token = loginClient.getToken(
                    'vitad',
                    '5c0f43408a980dc924c31fc98fce0122c3b785f5256b495f1ddd4e809ac6de53'
                )

                this.client = new JSONRpcClient({
                    url: 'https://user-api.simplybook.me',
                    headers: {
                        'X-Company-Login': 'vitad',
                        'X-Token': this.token
                    },
                    onerror: function (error) {
                        alert(error)
                    }
                })
            },
            getAvailableSlots(date) {
                this.slots = this.client.getStartTimeMatrix(date, date, 1, 1)[date]

                if(date === moment().add(1, 'days').format("YYYY-MM-DD")) {
                    var now = moment().format("HH:mm:ss")

                    this.slots = this.slots.filter((time) => time > now)
                }

                this.daktelaCalls = this.daktelaCalls.filter((call) => call.title.includes("Consultation request"))

                this.daktelaCalls.forEach(slot => {
                    var slotTime = moment(slot.reopen).format("HH:mm:ss")

                    if((moment(slot.reopen).get('minute')) < 30 && moment(slot.reopen).get('minute') > 0) {
                        if((moment(slot.reopen).get('minute')) < 30 && moment(slot.reopen).get('minute') > 15) {
                            slotTime = moment(slot.reopen).format("HH:30:ss")

                            this.slots = this.slots.filter((time) => time !== slotTime)
                        }
                        
                        slotTime = moment(slot.reopen).format("HH:00:ss")
                    }

                    if((moment(slot.reopen).get('minute')) < 60 && moment(slot.reopen).get('minute') > 30) {
                        if((moment(slot.reopen).get('minute')) < 60 && moment(slot.reopen).get('minute') > 45) {
                            slotTime = moment(slot.reopen).add(1, 'hour').format("HH:00:ss")

                            this.slots = this.slots.filter((time) => time !== slotTime)
                        }
                        
                        slotTime = moment(slot.reopen).format("HH:30:ss")
                    }

                    this.slots = this.slots.filter((time) => time !== slotTime)
                })

                this.$nextTick(() => {
                    $('#time').selectpicker('refresh');
                    $('#time').selectpicker('render');
                });
            },
            initDatepicker() {
                var that = this

                if(moment().isAfter(moment({H: 19}), 'hour')) {
                    var startDate = moment().add(2, 'days').toDate()
                } else {
                    var startDate = moment().add(1, 'days').toDate()
                }

                if(moment(startDate).day() === 6 ||moment(startDate).day() === 7) {
                    startDate = moment().weekday(7).toDate()
                }

                $(() => {
                    $('#datepicker-call')
                        .datepicker({
                            format: 'd. MM yyyy',
                            autoclose: true,
                            startDate: startDate,
                            endDate: moment().add(14, 'days').toDate(),
                            todayHighlight: true,
                            datesDisabled: ['18. Mai 2023'],
                            language: 'de',
                            daysOfWeekDisabled: '06',
                            container: '.form-input-datepicker',
                            orientation: 'top left'
                        })
                        .on('changeDate', ({ target, date }) => {
                            that.date = moment(date).format('YYYY-MM-DD')

                            that.getDaktelaCalls(that.date)
                        })

                    /* if(that.date !== null) {
                        $('#datepicker-call').datepicker('setDate', moment(that.date).toDate())
                    } else {
                        $('#datepicker-call').datepicker('setDate', startDate)
                    }  */     
                })
            },
            getDaktelaCalls(date) {
                var that = this

                const token = "3b8cbc9b2b1839558425fca34e7ce0612104ace3"
                const instance = axios.create()

                delete instance.defaults.headers.common['X-CSRF-TOKEN']
                delete instance.defaults.headers.common['X-Requested-With']

                instance.get('https://vitadio.daktela.com/api/v6/tickets.json?accessToken='+token+'&filter[logic]=and&filter[filters][0][field]=category.name&filter[filters][0][operator]=eq&filter[filters][0][value]=categories_63287e65252a1965378762&filter[filters][1][field]=reopen&filter[filters][1][operator]=isnotnull&filter[filters][2][field]=stage&filter[filters][2][operator]=neq&filter[filters][2][value]=CLOSE&fields[0]=reopen&fields[1]=title&fields[2]=name&fields[3]=stage&fields[4]=last_activity&fields[5]=last_activity_client&fields[6]=last_activity_operator=and&filter[filters][3][field]=reopen&filter[filters][3][operator]=gte&filter[filters][3][value]='+date+'+00:00:00&filter[filters][4][field]=reopen&filter[filters][4][operator]=lte&filter[filters][4][value]='+date+'+23:59:59')
                .then(function (e) {
                    that.daktelaCalls = e.data.result.data

                    that.getAvailableSlots(that.date)
                })    
                .catch(function (error) {
                    console.log(error.response)
                })
            },
        }
    }
</script>